import * as React from 'react';
import axios from 'axios';
import {HashRouter, Link, Redirect, Route, Switch} from 'react-router-dom';

// @ts-ignore
import Loadable from 'react-loadable';
import Icons from './Icons';
import {
  getBoutiqueColor,
  getShopRefInStorage,
  getUserId,
  sessionExpire,
} from './MonCompteAction';
import { Loader } from './Loader';
import { getHostApi, getRequestConfig, initEvent } from '../../utils';
import { fetchHasFeature } from '../../service/shop.api';

const loading = () => {
  return (
    <div className="text-center" style={{ marginTop: '100px' }}>
      <div>
            <span className="loader loader-quart-8">
              <img src="/order/images/ic_compte.svg"/>
            </span>
        <div className="textLoader">Chargement ...</div>
      </div>
    </div>
  );
};

const RenderOrders = Loadable({ loader: () => import('./RenderOrders'), loading: loading });
const RenderOrder = Loadable({ loader: () => import('./RenderOrder'), loading: loading });
const RenderOrderChronology = Loadable({ loader: () => import('./RenderOrderChronology'), loading: loading });
const RenderAddresses = Loadable({ loader: () => import('./RenderAddresses'), loading: loading });
const RenderAddress = Loadable({ loader: () => import('./RenderAddress'), loading: loading });
const RenderAddressForm = Loadable({ loader: () => import('./RenderAddressForm'), loading: loading });
const RenderProfil = Loadable({ loader: () => import('./RenderProfil'), loading: loading });
const RenderReclamations = Loadable({ loader: () => import('./RenderReclamations'), loading: loading });
const RenderReclamation = Loadable({ loader: () => import('./RenderReclamation'), loading: loading });
const RenderGallery = Loadable({ loader: () => import('./RenderGallery'), loading: loading });
const RenderFiles = Loadable({ loader: () => import('./RenderFiles'), loading: loading });
const RenderBat = Loadable({ loader: () => import('./RenderBat'), loading: loading });
const RenderDocuments = Loadable({ loader: () => import('./RenderDocuments'), loading: loading });

interface RenderMoncompteProps {
  history: any;
  location: any;
  route: any;
  createRouter: boolean;
}

class MonCompteApp extends React.Component<RenderMoncompteProps, any> {
  constructor(props: RenderMoncompteProps) {
    super(props);

    this.state = {
      menuResponsive: '/orders',
      requestRedirect: false,
      needSendFiles: false,
      displayFacturationDocuments: false,
      customer: {
        idClient: '',
        Email: '',
        Nom: '',
        Prenom: '',
        password: '',
      },
      featureSiret: false,
      canDisplayPage: false
    };
  }

  componentDidMount() {
    this._getCustomer();
    this._getNeedSendFiles();
    this._displayFacturationDocuments();
    fetchHasFeature('siret_adresse')
      .then(response => {
        if (response.data.feature) {
          this.setState({ featureSiret: response.data.feature });
        }
      })
      .finally(() => this.setState({ canDisplayPage: true }));
  }

  _handleChangeMenu = (event: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({
      menuResponsive: event.target.value,
      requestRedirect: true,
    });
  }

  /**
   * Fonction retournant un utilisateur
   *
   * @returns {Order[]}
   * @private
   */
  _getCustomer() {
    document.dispatchEvent(initEvent('dp-loading'));
    axios.get(`${getHostApi()}/customers/${getUserId()}`, getRequestConfig())
      .then((response) => {
        if (response.data.customer) {
          this.setState({ customer: response.data.customer });
          MonCompteApp.updateUserInfos(this._getCustomerToString());
        }
        document.dispatchEvent(initEvent('dp-loaded'));
      }).catch((error) => {
        console.log(error);
      if (error && error.response && error.response.status === 401) {
        sessionExpire();
      }
      document.dispatchEvent(initEvent('dp-loaded'));
    });
  }

  _getNeedSendFiles() {
    axios.get(`${getHostApi()}/customers/${getUserId()}/need-send-files`, getRequestConfig())
    .then((response) => {
      if (response.data) {
        this.setState({ needSendFiles: response.data});
      }
      document.dispatchEvent(initEvent('dp-loaded'));
    }).catch((error) => {
      console.log(error);
      document.dispatchEvent(initEvent('dp-loaded'));
    });
  }

  _displayFacturationDocuments() {
    axios.get(`${getHostApi()}/customers/${getUserId()}/iban`, getRequestConfig())
        .then((response) => {
          if (response.data?.iban?.length > 0 || response.data?.reclamationEnCours) {
            this.setState({ displayFacturationDocuments: response.data});
          }
          document.dispatchEvent(initEvent('dp-loaded'));
        }).catch((error) => {
      console.log(error);
      document.dispatchEvent(initEvent('dp-loaded'));
    });
  }

  static updateUserInfos(username: string) {
    const userInfos = document.getElementById('infosMembreUsername');
    if (userInfos !== undefined && userInfos != null) {
      userInfos.innerHTML = username;
    }
  }

  _getCustomerToString = () => {
    return `${this.state.customer.Prenom}`;
  }

  render() {

    /**
     * Fonction permettant de générer les liens du menu
     *
     * @param {boolean} wish : Veut-on afficher les anciens liens ?
     * @param {string} text : Texte du lien apparaissant en front
     * @param {string} href : Lien href de l'ancien lien
     * @param {string} route : Nouvelle route créée
     * @returns {any}
     */
    const displayOldLink = (wish: boolean, text: string, href: string | null = null, route: string | null = null, icon: any) => {
      if (wish) {
        return (
          <a href={href as string} className="black d-flex justify-content-between">
            <span>{text}</span>
            <span>{icon}</span>
          </a>
        );
      }

      return (
        <Link to={route as string} className="black d-flex justify-content-between">
          <span>{text}</span>
          <span>{icon}</span>
        </Link>
      );
    };

    const renderLi = (text: any) => {
      const boutique = getShopRefInStorage();

      if (text.props.href && text.props.href.indexOf('mes-bat') > -1) {
        if (boutique === 'TE' || boutique === 'TO' || boutique === 'TH') {
          return (
            <li className="border-bottom border-dark pt-2 pb-2 text-uppercase bold">{text}</li>
          );
        }
      } else {
        return (
          <li className="border-bottom border-dark pt-2 pb-2 text-uppercase bold">{text}</li>
        );
      }
    };

    const displayFileMenu = () => {
      if (this.state.needSendFiles ||  getShopRefInStorage() === 'TH' ) {
        return renderLi(displayOldLink(false, 'Envoi des fichiers', null, '/files',
          <Icons icon="file_upload" size={20} color={getBoutiqueColor()}/>));
      }
    };

    /*const displayGallery = () => {
      if (getShopRefInStorage() === 'TE' || getShopRefInStorage() === 'TO') {
        return renderLi(displayOldLink(false, 'Ma galerie', null, '/gallery',
          <Icons icon="collections" size={20} color={getBoutiqueColor()}/>));
      }
    };*/

    const displayBatMenu = () => {
      if (getShopRefInStorage() === 'TE' || getShopRefInStorage() === 'TO' || getShopRefInStorage() === 'TH') {
        return renderLi(displayOldLink(false, 'Mes BAT', null, '/bat',
          <Icons icon="bat" size={20} color={getBoutiqueColor()}/>));
      }
    };

    const displayDocumentsMenu = () => {
      if (this.state.displayFacturationDocuments) {
        return renderLi(displayOldLink(false, 'Facturation / Documents', null, '/documents',
            <Icons icon="" size={20} color={getBoutiqueColor()}/>));
      }
    };

    const renderUser = () => {
      const customerName = this._getCustomerToString();
      return (
        <div>
          <p className="font14 p-0 m-0 pb-3 infosMembre">
            Bonjour <span className="bold">{customerName}</span>
          </p>
        </div>
      );
    };

    const displayFileMenuResponsive = () => {
      if (getShopRefInStorage() === 'TE' || getShopRefInStorage() === 'TO' || getShopRefInStorage() === 'DT' || getShopRefInStorage() === 'TH') {
        return <option value="/files">Envoi des fichiers</option>;
      }
    };

    const displayBatMenuResponsive = () => {
      if (getShopRefInStorage() === 'TE' || getShopRefInStorage() === 'TO' || getShopRefInStorage() === 'TH') {
        return <option value="/bat">Mes BAT</option>;
      }
    };

    const displayDocumentsMenuResponsive = () => {
      if (this.state.displayFacturationDocuments) {
        return <option value="/documents">Facturation / Documents</option>;
      }
    };

    const renderResponsiveMenu = () => {
      return (
        <div className="col-12 d-none menuCompteResponsive mb-2">
          {renderUser()}
          <select onChange={this._handleChangeMenu} value={this.state.menuResponsive} className="w100">
            <option value="/orders">Mes commandes</option>
            {displayFileMenuResponsive()}
            {displayBatMenuResponsive()}
            <option value="/profil">Mon profil</option>
            <option value="/addresses">Mon carnet d'adresses</option>
            {displayDocumentsMenuResponsive()}
            <option value="/?deconnexion">Se d&eacute;connecter</option>
          </select>
        </div>
      );
    };

    /**
     * Fonction permettant d'afficher le menu
     *
     * @returns {any}
     */
    const renderMenu = () => {
      const shopRef = getShopRefInStorage();
      
      let logoutHref: string = '/?deconnexion';
      if(['DT', 'TH'].includes(shopRef)) {
        logoutHref = `/fr/?deconnexion`;
      }

      return (
        <div className="col-3 menuCompte">
          {renderUser()}
          <ul className="list-unstyled ">
            {renderLi(displayOldLink(false, 'Mes commandes', null, '/orders',
              <Icons icon="colis" size={20} color={getBoutiqueColor()}/>))}
            {displayFileMenu()}
            {displayBatMenu()}
            {/* displayGallery() */}
            {renderLi(displayOldLink(false, 'Mon profil', null, '/profil',
              <Icons icon="profil" size={20} color={getBoutiqueColor()}/>))}
            {renderLi(displayOldLink(false, 'Mon carnet d\'adresses', null, '/addresses',
              <Icons icon="carnet" size={20} color={getBoutiqueColor()}/>))}
            {displayDocumentsMenu()}
            {renderLi(displayOldLink(true, 'Se déconnecter', logoutHref, null,
              <Icons icon="keyboard_arrow_right" size={20} color={getBoutiqueColor()}/>))}
          </ul>
        </div>
      );
    };

    /**
     * Fonction retournant une route
     *
     * @param {string} path
     * @param component
     * @returns {any}
     */
    const renderRoute = (path: string, component: any) => {
      return (
        <Route exact path={path} component={component}/>
      );
    };

    /**
     * Fonction retournant toutes les routes du compte
     *
     * @returns {any}
     */
    const renderRoutes = () => {
      let route = <div></div>;
      if (this.state.canDisplayPage) {
        route = (
          <div>
            {renderRoute('/', RenderOrders)}
            {renderRoute('/orders', RenderOrders)}
            {renderRoute('/gallery', RenderGallery)}
            {renderRoute('/profil', RenderProfil)}
            {renderRoute('/addresses', RenderAddresses)}
            {renderRoute('/files', RenderFiles)}
            {renderRoute('/bat', RenderBat)}
            {renderRoute('/documents', RenderDocuments)}
  
            {renderRoute('/bat/:id', RenderBat)}
            {renderRoute('/files/:id', RenderFiles)}
            {renderRoute('/orders/:id', RenderOrder)}
            {renderRoute('/orders/:id/chronology', RenderOrderChronology)}
            {renderRoute('/orders/:id/reclamations', RenderReclamations)}
            {renderRoute('/orders/:id/reclamation', RenderReclamation)}

            {renderRoute('/addresses/address', this.state.featureSiret ? RenderAddressForm : RenderAddress)}
            {renderRoute('/addresses/address/:id', this.state.featureSiret ? RenderAddressForm : RenderAddress)}
            {
              // TODO: Créer une vue spécifique à cette route
              renderRoute('/addresses/address/:type/:orderId', RenderAddress)
            }
          </div>
        );
      }
      return route;
    };

    const renderContent = () => {
      return (
        <div className="col-lg-9 col-12">
          <Loader/>
          {renderRoutes()}
        </div>
      );
    };

    const renderRedirect = () => {
      if (this.state.requestRedirect) {
        this.setState({
          requestRedirect: false,
        });

        if (this.state.menuResponsive === '/?deconnexion') {
          window.location.href = '/?deconnexion';
        }
        return (<Redirect to={this.state.menuResponsive}/>);
      }
    };

    const content = (
      <div>
        <div className={'row position-relative d-flex '}>
          {renderMenu()}
          {renderResponsiveMenu()}
          {renderRedirect()}
          {renderContent()}
        </div>
      </div>
    );

    return (this.props.createRouter) ? (
      <HashRouter>
        <Switch>
          {content}
        </Switch>
      </HashRouter>
    ) : content;
  }
}

export default MonCompteApp as any;
